import {
  ContestBasic,
  ContestCalculatedFields,
  ContestCalculatedGateway,
  ContestHudlInfo,
  ContestTeamBasic,
  ContestTeamCalculatedFields
} from '@maxpreps/apiserviceclients/apiModels';
import { getCurrentAndOpponentTeams } from '@maxpreps/shared/functions/utils/contestUtils';
import { sortList } from '@maxpreps/shared/functions/utils/sortHelpers';

// This model is not perfect yet. I can't figure out which API models this is based on.
export interface IClientContestTeam
  extends ContestTeamBasic,
    ContestTeamCalculatedFields {
  teamId: string;
  allSeasonId: string;
  isTeamTBA: boolean;
}

export interface IClientContest
  extends ContestBasic,
    ContestCalculatedFields,
    ContestHudlInfo {
  currentTeam: IClientContestTeam;
  opponentTeam: IClientContestTeam;
}

const serializeSchedule = (
  calculatedContests: ContestCalculatedGateway[],
  teamId: string
): IClientContest[] => {
  const serializedSchedule = calculatedContests.map(c => {
    const { currentTeam, opponentTeam } = getCurrentAndOpponentTeams(
      c.contest.teams,
      teamId,
      c.calculatedFields.teamsCalculated
    );

    return {
      ...c.contest,
      ...c.calculatedFields,
      ...c.hudlInfo,
      currentTeam,
      opponentTeam
    };
  });

  const list: IClientContest[] = sortList(serializedSchedule, 'date', {
    isDescending: false,
    isShowEmptyFirst: true
  });

  return list;
};

export default serializeSchedule;
